import React from 'react';
import WhyICN1 from '../../images/WhyIcn1.png';
import WhyICN2 from '../../images/WhyIcn2.png';
import WhyICN3 from '../../images/WhyIcn3.png';
import WhyICN4 from '../../images/WhyIcn4.png';
import WhyICN5 from '../../images/JumpStart_4.png';
import WhyICN6 from '../../images/WhyIcn6.png';
import WhyICN7 from '../../images/WhyIcn7.png';
import WhyICN8 from '../../images/WhyIcn8.png';

const WhyChooseUs = () => {
    return (
        <>
            <section className="WhyChooseSec">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="Headings text-center">Why Choose Us</h2>
                            <p className="SubHeading text-center">Where Aspiration Meets Achievement: Your Journey to Career Brilliance Starts Here!</p>
                        </div>
                    </div>
                    <div className="row gy-4">
                        <div className="col-lg-6 col-xl-3 col-12">
                            <div className="whyDiv">
                                <div className="icn">
                                    <img src={WhyICN1} alt="icon" />
                                </div>
                                <div className="Con">
                                    <h6>
                                        Trusted by Learners
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-3 col-12">
                            <div className="whyDiv">
                                <div className="icn">
                                    <img src={WhyICN2} alt="icon" />
                                </div>
                                <div className="Con">
                                    <h6>
                                        Industry Expert Trainers
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-3 col-12">
                            <div className="whyDiv">
                                <div className="icn">
                                    <img src={WhyICN3} alt="icon" />
                                </div>
                                <div className="Con">
                                    <h6>
                                        Completely Practical Oriented
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-3 col-12">
                            <div className="whyDiv">
                                <div className="icn">
                                    <img src={WhyICN4} alt="icon" />
                                </div>
                                <div className="Con">
                                    <h6>
                                        Industry-Recognised Certification
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-3 col-12">
                            <div className="whyDiv">
                                <div className="icn">
                                    <img src={WhyICN5} alt="icon" />
                                </div>
                                <div className="Con">
                                    <h6>
                                        Online & Offline Batches
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-3 col-12">
                            <div className="whyDiv">
                                <div className="icn">
                                    <img src={WhyICN6} alt="icon" />
                                </div>
                                <div className="Con">
                                    <h6>
                                        Hands on Projects
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-3 col-12">
                            <div className="whyDiv">
                                <div className="icn">
                                    <img src={WhyICN7} alt="icon" />
                                </div>
                                <div className="Con">
                                    <h6>
                                        Career Assistance
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-3 col-12">
                            <div className="whyDiv">
                                <div className="icn">
                                    <img src={WhyICN8} alt="icon" />
                                </div>
                                <div className="Con">
                                    <h6>
                                        Industry Comprehensive Curriculum
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default WhyChooseUs